module.exports = __webpack_public_path__ + "db698f56e626b756e635934d825e2e55.svg";